export interface IProps {
  id?: number;
  text?: string;
  image?: string;
  type?: ProjectCardType;
}

export enum ProjectCardType {
  PROJECTS_PAGE = "pagina proiecte",
  PROJECTS_CAROUSEL = "carousel proiecte",
}
